export * from './edge-resize.directive';
